import DevicePageTemplate from "./DevicePageTemplate";
import {useTranslation} from "react-i18next";
import {gql} from "@apollo/client";
import WaterDropIcon from "@mui/icons-material/WaterDrop";

const PAGINATE_MAKMINI = gql`
    query PaginateDeviceMakmini($pagination: Pagination!, $sortBy: [SortBy!], $criteria: DeviceMakminiCriteria) {
        paginateDeviceMakmini(pagination: $pagination, sortBy: $sortBy, criteria: $criteria) {
            pageInfo {
                totalElements
                totalPages
                numberOfElements
                pageNumber
                pageSize
            }
            content {
                id
                serialNumber
                installationDate
                equipmentTypes
                flowAThreshold
                flowBThreshold
                conductivityAMinThreshold
                conductivityAMaxThreshold
                conductivityBMinThreshold
                conductivityBMaxThreshold
                waterTemperatureAMinThreshold
                waterTemperatureAMaxThreshold
                waterTemperatureBMinThreshold
                waterTemperatureBMaxThreshold
                location {
                    id
                    name
                    address {
                        fullAddress
                        latitude
                        longitude
                    }
                    customer {
                        id
                        name
                        reseller {
                            id
                            name
                        }
                    }
                }
                updatedTimestamp
                deleted
            }
        }
    }
`;

const CREATE_DEVICE_MAKMINI = gql`
    mutation CreateDeviceMakmini($input: DeviceMakminiInput!) {
        createDeviceMakmini(input: $input) {
            id
            serialNumber
            installationDate
            equipmentTypes
            updatedTimestamp
            deleted
        }
    }
`;

const UPDATE_DEVICE_MAKMINI = gql`
    mutation UpdateDeviceMakmini($id: ID!, $input: DeviceMakminiInput!) {
        updateDeviceMakmini(id: $id, input: $input) {
            id
            serialNumber
            installationDate
            equipmentTypes
            updatedTimestamp
            deleted
        }
    }
`;

const DELETE_DEVICE_MAKMINI = gql`
    mutation DeleteDeviceMakmini($id: ID!) {
        deleteDeviceMakmini(id: $id)
    }
`;

const queries = {
    PAGINATE: PAGINATE_MAKMINI,
    CREATE: CREATE_DEVICE_MAKMINI,
    UPDATE: UPDATE_DEVICE_MAKMINI,
    DELETE: DELETE_DEVICE_MAKMINI,
};

export default function Makmini() {
    const {t} = useTranslation();
    return <DevicePageTemplate title="Makmini" subtitle={t("makmini.subtitle")} queries={queries} icon={<WaterDropIcon/>}/>;
}
